var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"kb-revert",attrs:{"title":_vm.title || _vm.$t('knowledgebase.revert')},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('i',{staticClass:"fa fa-undo"})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f42fa32","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/knowledge-base/kb-revert.vue
// module id = 893
// module chunks = 1